<script>
import ClockStatusButton from "../molecules/ClockStatusButton.vue";
import ClockActionPanel from "../molecules/ClockActionPanel.vue";
import StatusAwareComponent from "../StatusAwareComponent.vue";
import {
  changeWorkStatus,
  EVENT_TIME_ENTRY_ADDED,
  getTodayAttendanceTimesheet
} from "../services/AttendanceTracking.service";
import {$listenForGlobalEvent} from "../../../services/EventBus";

export default {
  name: "AttendanceClockWidget",
  components: {ClockActionPanel, ClockStatusButton},
  extends: StatusAwareComponent,
  data() {
    return {
      currentStatus: this.status
    }
  },
  methods: {
    changeStatus(actionStatus) {
      changeWorkStatus(actionStatus).then(() => {
        this.sync();
        this.$emit('statusChange', actionStatus)
      })
    },
    sync() {
      getTodayAttendanceTimesheet().then((status) => {
        if (status) {
          this.workTime = Number(status.total_shift_duration);
          this.currentStatus = status.shift_end === null ? this.statuses.working : this.statuses.completed;
        }
      });
    }
  },
  mounted() {
    this.sync();
    $listenForGlobalEvent(EVENT_TIME_ENTRY_ADDED, this.sync);
  }
}
</script>

<template>
  <div class="dropdown h-100">
    <div class="dropdown-toggle h-100" type="button" data-bs-toggle="dropdown" data-bs-auto-close="false"
         aria-expanded="false">
      <clock-status-button :status="currentStatus" :time="workTime"/>
    </div>
    <div class="dropdown-menu dropdown-menu-end animated--grow-in py-4">
      <clock-action-panel @statusChange="changeStatus" :status="currentStatus" :time="workTime"/>
    </div>
  </div>
</template>
